import type { EndpointDefinition } from "../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getWorkspaceResources: {
        route: "/workspaces/:workspaceId/resources",
        method: "GET"
    },
    updateWorkspaceResource: {
        route: "/workspaces/:workspaceId/resources/:resourceType/:resourceId",
        method: "PUT"
    },
    deleteWorkspaceResource: {
        route: "/workspaces/:workspaceId/resources/:resourceType/:resourceId",
        method: "DELETE"
    },
    createWorkspaceResource: {
        route: "/workspaces/:workspaceId/resources",
        method: "POST"
    },
    getUserPermissionsToResource: {
        route: "/workspaces/:workspaceId/resources/:resourceType/:resourceId/user-permissions",
        method: "GET"
    },
    updateWorkspaceResourceUsers: {
        route: "/workspaces/:workspaceId/resources/:resourceType/:resourceId/users",
        method: "PUT"
    },
    getWorkspacePermissionsToResource: {
        route: "/workspaces/:workspaceId/resources/:resourceType/:resourceId/permissions",
        method: "GET"
    },
    getCollaborationInvitesToResource: {
        route: "/workspaces/:workspaceId/resources/:resourceType/:resourceId/invites",
        method: "GET"
    },
    getWorkspaceIdForResource: {
        route: "/workspaces/resources/:resourceId/workspace-id",
        method: "GET"
    }
};
